import React from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { useParams } from 'react-router-dom';
// import { AllPackages, GetOnePackage } from '../../../Redux/actions/HomeAction';
import { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import ImageGallery from 'react-image-gallery';
import $, { map } from 'jquery';
import { GET_ONE_PART_DETAIL_LIST } from '../../../../Redux/Actions/ActionType';
import 'react-image-gallery/styles/css/image-gallery.css';
import { useTranslation } from 'react-i18next';

var config = {
  headers: {
    'Content-Type': 'application/json',
    Authorization: sessionStorage.getItem('loged_In_auth'),
  },
};

const images = [
  {
    original: 'assets/images/service-provider/garages/banner.jpg',
  },
  {
    original: 'assets/images/service-provider/garages/banner-2.jpg',
  },
];
export default function SparePartsShopDetail() {
  const { t } = useTranslation();
  var home = useSelector((state) => state.home);
  const OnepartDetailList = home?.OnePartDetailList;
  const dispatch = useDispatch();
  const { productId } = useParams();
  // const data = { packID: id };

  const fetchDetail = async (data) => {
    var object = { productId };
    console.log('this is fatch ondata ', object);
    let query = '';
    Object.keys(object).forEach((key) => {
      console.log('this is object key', key);
      query += key + '=' + object[key] + '&';
    });
    query = query.slice(0, -1);
    console.log('this is the,', query);
    try {
      // console.log('fetch data part', data);
      axios

        .get(
          `https://api.carsavenue.com/api/admin/part/listing` +
            '?' +
            query,

          config
        )

        .then((res) => {
          console.log('heeee<<<<', res);
          dispatch({
            type: GET_ONE_PART_DETAIL_LIST,
            payload: res.data.response,
          });

          // setgarageDataDetail(res);

          console.log('heeee<<<<', res);
        })
        .catch((err) => {
          console.log(err);
        });
    } catch (err) {
      // Swal.fire('Incorrect Credentials', '', 'error');
    }
  };

  useEffect(() => {
    if (productId && productId !== '') fetchDetail({ productId });
    // console.log('home data', garageDataDetail);
  }, [productId]);
  return (
    <div>
      <div class="user-banner">
        <div class="height-banner">
          <div class="bxslider">
            <ImageGallery items={images} class="img-fluid" />
            {/* <div><img src="assets/images/service-provider/garages/banner.jpg" alt="" class="img-fluid"/></div> */}
            {/* <div><img src="assets/images/service-provider/garages/banner-2.jpg" alt="" class="img-fluid"/></div> */}
          </div>
        </div>

        <div class="user-logo-holder">
          <div class="container">
            <div class="user-logo-holder-wrap">
              <div class="row align-items-center justify-content-between">
                <div class="col-12 col-sm-12 col-md-6 mb-3 mb-sm-3 mb-md-0">
                  <div class="row align-items-center">
                    <div class="col-4 col-sm-4 col-md-3">
                      <img
                        src="assets/images/user/garages/garage-logo/a.jpg"
                        alt=""
                        class="img-fluid user-garage-logo"
                      />
                    </div>
                    <div class="col-8 col-sm-8 col-md-auto">
                      <h5 class="mb-3">Wyoming fleet & auto</h5>
                      <ul class="list-inline mb-0 wpm">
                        <li
                          class="list-inline-item"
                          data-toggle="tooltip"
                          data-placement="top"
                          title="Calendar"
                        >
                          <a
                            href="javascript:void(0);"
                            data-toggle="modal"
                            data-target="#calendar-modal"
                          >
                            <i class="far fa-calendar-alt"></i>
                          </a>
                        </li>
                        <li
                          class="list-inline-item"
                          data-toggle="tooltip"
                          data-placement="top"
                          title="Whatsapp"
                        >
                          <a href="https://wa.me/12345678">
                            <i class="fab fa-whatsapp"></i>
                          </a>
                        </li>
                        <li
                          class="list-inline-item"
                          data-toggle="tooltip"
                          data-placement="top"
                          title="Call"
                        >
                          <a href="tel:12345678">
                            <i class="fas fa-phone"></i>
                          </a>
                        </li>
                        <li
                          class="list-inline-item"
                          data-toggle="tooltip"
                          data-placement="top"
                          title="Location Map"
                        >
                          <a
                            href="javascript:void(0);"
                            data-toggle="modal"
                            data-target="#map-modal"
                          >
                            <i class="fas fa-map-marker-alt"></i>
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>

                <div class="col-12 col-sm-12 col-md-auto">
                  <p class="mb-3">
                    <span class="open-time">Open now</span> |{' '}
                    <span class="close-time">Close 10:00 PM</span>
                  </p>
                  <ul class="list-inline mb-0">
                    <li class="list-inline-item">
                      <a href="javascript:void(0);">
                        <img
                          src="assets/images/service-provider/facebook.png"
                          alt=""
                        />
                      </a>
                    </li>
                    <li class="list-inline-item">
                      <a href="javascript:void(0);">
                        <img
                          src="assets/images/service-provider/instagram.png"
                          alt=""
                        />
                      </a>
                    </li>
                    <li class="list-inline-item">
                      <a href="javascript:void(0);">
                        <img
                          src="assets/images/service-provider/twitter.png"
                          alt=""
                        />
                      </a>
                    </li>
                    <li class="list-inline-item">
                      <a href="javascript:void(0);">
                        <img
                          src="assets/images/service-provider/youtube.png"
                          alt=""
                        />
                      </a>
                    </li>
                    <li class="list-inline-item">
                      <a href="javascript:void(0);">
                        <img
                          src="assets/images/service-provider/linkedin.png"
                          alt=""
                        />
                      </a>
                    </li>
                    <li class="list-inline-item">
                      <a href="javascript:void(0);">
                        <img
                          src="assets/images/service-provider/snapchat.png"
                          alt=""
                        />
                      </a>
                    </li>
                    <li class="list-inline-item">
                      <a href="javascript:void(0);">
                        <img
                          src="assets/images/service-provider/googleplus.png"
                          alt=""
                        />
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
              {/* <!-- MAP  MODAL --> */}
              <div
                class="modal fade"
                id="map-modal"
                tabindex="-1"
                aria-labelledby="exampleModalLabel"
                aria-hidden="true"
              >
                <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
                  <div class="modal-content">
                    <div class="modal-header">
                      <h5 class="modal-title" id="exampleModalLabel">
                        Map
                      </h5>
                      <button
                        type="button"
                        class="close"
                        data-dismiss="modal"
                        aria-label="Close"
                      >
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                    <div class="modal-body">
                      <iframe
                        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1781287.9077480363!2d46.414478775959395!3d29.30938918651801!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3fc5363fbeea51a1%3A0x74726bcd92d8edd2!2sKuwait!5e0!3m2!1sen!2sin!4v1616309027970!5m2!1sen!2sin"
                        width="100%"
                        height="450"
                        style={{ border: '0' }}
                        allowfullscreen=""
                        loading="lazy"
                      ></iframe>
                    </div>
                    <div class="modal-footer">
                      <button
                        type="button"
                        class="btn btn-secondary"
                        data-dismiss="modal"
                      >
                        {t('Close')}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              {/* <!-- MAP  MODAL --> */}

              {/* <!-- CALENDAR  MODAL --> */}
              <div
                class="modal fade"
                id="calendar-modal"
                tabindex="-1"
                aria-labelledby="exampleModalLabel"
                aria-hidden="true"
              >
                <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
                  <div class="modal-content">
                    <div class="modal-header">
                      <h5 class="modal-title">{t('Timing')}</h5>
                      <button
                        type="button"
                        class="close"
                        data-dismiss="modal"
                        aria-label="Close"
                      >
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                    <div class="modal-body">
                      <table class="table table-bordered table-striped">
                        <tbody>
                          <tr>
                            <td scope="col">Sunday</td>
                            <td scope="col">08:00 AM</td>
                            <td scope="col">08:00 PM</td>
                          </tr>
                          <tr>
                            <td scope="col">Monday</td>
                            <td scope="col">08:00 AM</td>
                            <td scope="col">08:00 PM</td>
                          </tr>
                          <tr>
                            <td scope="col">Tuesday</td>
                            <td scope="col">08:00 AM</td>
                            <td scope="col">08:00 PM</td>
                          </tr>
                          <tr>
                            <td scope="col">Wednesday</td>
                            <td scope="col">08:00 AM</td>
                            <td scope="col">08:00 PM</td>
                          </tr>
                          <tr>
                            <td scope="col">Thursday</td>
                            <td scope="col">08:00 AM</td>
                            <td scope="col">08:00 PM</td>
                          </tr>
                          <tr>
                            <td scope="col">Friday</td>
                            <td scope="col">Closed</td>
                            <td scope="col">&nbsp;</td>
                          </tr>
                          <tr>
                            <td scope="col">Saturday</td>
                            <td scope="col">08:00 AM</td>
                            <td scope="col">08:00 PM</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <div class="modal-footer">
                      <button
                        type="button"
                        class="btn btn-secondary"
                        data-dismiss="modal"
                      >
                        {t('Close')}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              {/* <!-- CALENDAR  MODAL --> */}
            </div>
          </div>
        </div>
      </div>

      <div class="main-content-area">
        <div class="container">
          <h3>About Us</h3>
          <p>
            We are an innovative mobile auto service that is the ideal way to
            save your time on all of your tire maintenance needs,. From tire
            changeovers for small cars to SUV , to Oil Filter Change , Battery &
            Brake trimming . Garage has got you covered.
          </p>

          <h5>Sensors</h5>
          <div class="row mb-4">
            <div class="col-6 col-sm-6 col-md-2 mb-4">
              <div class="user-spare-parts-parts">
                <a href="javascript:void(0);">
                  <div class="line-a">
                    <img
                      src="assets/images/service-provider/spare-parts/starting-system/airbag-sensor.jpg"
                      alt=""
                      class="img-fluid"
                    />
                  </div>
                  <div class="line-b">Airbag Sensors</div>
                </a>
              </div>
            </div>
            <div class="col-6 col-sm-6 col-md-2 mb-4">
              <div class="user-spare-parts-parts">
                <a href="javascript:void(0);">
                  <div class="line-a">
                    <img
                      src="assets/images/service-provider/spare-parts/starting-system/fuel-level-sensor.jpg"
                      alt=""
                      class="img-fluid"
                    />
                  </div>
                  <div class="line-b">Fuel Level Sensor</div>
                </a>
              </div>
            </div>
            <div class="col-6 col-sm-6 col-md-2 mb-4">
              <div class="user-spare-parts-parts">
                <a href="javascript:void(0);">
                  <div class="line-a">
                    <img
                      src="assets/images/service-provider/spare-parts/starting-system/oxygen-sensor.jpg"
                      alt=""
                      class="img-fluid"
                    />
                  </div>
                  <div class="line-b">Oxygen Sensor</div>
                </a>
              </div>
            </div>
            <div class="col-6 col-sm-6 col-md-2 mb-4">
              <div class="user-spare-parts-parts">
                <a href="javascript:void(0);">
                  <div class="line-a">
                    <img
                      src="assets/images/service-provider/spare-parts/starting-system/knock-sensor.jpg"
                      alt=""
                      class="img-fluid"
                    />
                  </div>
                  <div class="line-b">Knock Sensor</div>
                </a>
              </div>
            </div>
            <div class="col-6 col-sm-6 col-md-2 mb-4">
              <div class="user-spare-parts-parts">
                <a href="javascript:void(0);">
                  <div class="line-a">
                    <img
                      src="assets/images/service-provider/spare-parts/starting-system/coolant-sensor.jpg"
                      alt=""
                      class="img-fluid"
                    />
                  </div>
                  <div class="line-b">Coolant Sensor</div>
                </a>
              </div>
            </div>
            <div class="col-6 col-sm-6 col-md-2 mb-4">
              <div class="user-spare-parts-parts">
                <a href="javascript:void(0);">
                  <div class="line-a">
                    <img
                      src="assets/images/service-provider/spare-parts/starting-system/the-mass--air-flow-sensor.jpg"
                      alt=""
                      class="img-fluid"
                    />
                  </div>
                  <div class="line-b">The Mass Air Flow Sensor</div>
                </a>
              </div>
            </div>
          </div>

          <h5>Starting System</h5>
          <div class="row mb-4">
            <div class="col-6 col-sm-6 col-md-2 mb-4">
              <div class="user-spare-parts-parts">
                <a href="javascript:void(0);">
                  <div class="line-a">
                    <img
                      src="assets/images/service-provider/spare-parts/starting-system/start-stop-a.jpg"
                      alt=""
                      class="img-fluid"
                    />
                  </div>
                  <div class="line-b">Power Stop K2069-36 Z36</div>
                </a>
              </div>
            </div>
            <div class="col-6 col-sm-6 col-md-2 mb-4">
              <div class="user-spare-parts-parts">
                <a href="javascript:void(0);">
                  <div class="line-a">
                    <img
                      src="assets/images/service-provider/spare-parts/starting-system/start-stop-b.jpg"
                      alt=""
                      class="img-fluid"
                    />
                  </div>
                  <div class="line-b">Power Stop K2069-36 Z36</div>
                </a>
              </div>
            </div>
            <div class="col-6 col-sm-6 col-md-2 mb-4">
              <div class="user-spare-parts-parts">
                <a href="javascript:void(0);">
                  <div class="line-a">
                    <img
                      src="assets/images/service-provider/spare-parts/starting-system/start-stop-c.jpg"
                      alt=""
                      class="img-fluid"
                    />
                  </div>
                  <div class="line-b">Power Stop K2069-36 Z36</div>
                </a>
              </div>
            </div>
            <div class="col-6 col-sm-6 col-md-2 mb-4">
              <div class="user-spare-parts-parts">
                <a href="javascript:void(0);">
                  <div class="line-a">
                    <img
                      src="assets/images/service-provider/spare-parts/starting-system/start-stop-a.jpg"
                      alt=""
                      class="img-fluid"
                    />
                  </div>
                  <div class="line-b">Power Stop K2069-36 Z36</div>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
